import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Components
import enviroments from './Services/enviroments';

// Views
import SelectContratacionFibra from './Views/Public/SelectContratacionFibra';
import SelectContratacionMovil from './Views/Public/SelectContratacionMovil';
import Estrategia from './Views/Estrategia/Estrategia';
import AdminEquipos from './Views/Admin/AdminEquipos';
import Navbar from './Components/Navbar/Navbar';
import Dashboard from './Views/Admin/Dashboard';
import Equipos from './Views/Public/Equipos';
import Ofertas from './Views/Public/Ofertas';
import Movil from './Views/Public/Movil';
import Hogar from './Views/Public/Hogar';
import Login from './Views/Auth/Login';
import ScrollToSection from './Components/ScrollToSection/ScrollToSection';


const App = () => {
    let urlDemo = enviroments.urlBase;

    return (
        <BrowserRouter>
            <ScrollToSection />
            <Routes>
                <Route path={`${urlDemo}/`} element={<Navbar> <Movil /> </Navbar>} />
                <Route path={`${urlDemo}/Admin/equipos`} exact element={<AdminEquipos />} />
                <Route path={`${urlDemo}/planes-moviles`} element={<Navbar><Movil /></Navbar>} />
                <Route path={`${urlDemo}/internet-hogar/:tipo`} element={<Navbar><Hogar /></Navbar>} />
                <Route path={`${urlDemo}/contratacion`} exact element={<SelectContratacionFibra />} />
                <Route path={`${urlDemo}/contratacionMovil`} exact element={<SelectContratacionMovil />} />
                <Route path={`${urlDemo}/equipos`} element={<Navbar><Equipos /></Navbar>} />
                <Route path={`${urlDemo}/ofertas`} element={<Navbar><Ofertas /></Navbar>} />
                <Route path={`${urlDemo}/Admin/Dashboard`} exact element={<GoogleReCaptchaProvider
                    reCaptchaKey={enviroments?.site_key}
                    useEnterprise={true}
                ><Dashboard /></GoogleReCaptchaProvider>} />
                <Route path={`${urlDemo}/Login`} exact element={<Login />} />
                <Route path={`${urlDemo}/estrategia`} exact element={<Estrategia />} />

                <Route path={`${urlDemo}/*`} element={<Navigate to={`${urlDemo}/`} replace />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App
